import script from "./ModuleDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModuleDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ModuleDialog.vue?vue&type=style&index=0&id=235c5948&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235c5948"]])

export default __exports__